<template>
  <list-container :list="addresses">
    <template v-slot:not-found>
      <v-row class="py-8" no-gutters>
        <v-col cols="12">
          <v-icon size="150" color="grey" v-if="$vuetify.breakpoint.mdAndUp">location_on</v-icon>
          <v-icon class="mb-2" size="100" color="grey" v-else>location_on</v-icon>
          <div class="headline font-weight-regular mb-xl-5 mb-lg-5 mb-md-5 mb-sm-4 mb-4 not-found-title">No se encontraron direcciones.</div>
          <div class="mb-xl-1 mb-lg-1 mb-md-1">
            <v-btn class="text-none" color="blue" dark large outlined @click="goToRouteByName('Create-address')">
              <v-icon left>add</v-icon>Crear Nueva
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-slot:items>
      <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-0 pt-0 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters v-if="drawItems">
        <v-col class="pl-5" xl="8" lg="9" md="11" sm="12" cols="12" v-if="$vuetify.breakpoint.mdAndUp">
          <div class="mb-4 pr-1 text-right grey--text text--darken-2">
            {{ itemsLength }}
            <span v-if="itemsLength == 1">Dirección encontrada</span>
            <span v-else>Direcciones encontradas</span>
          </div>
        </v-col>
        <v-col class="toolbar-quantity" v-else>
          <v-toolbar dense>
            <v-toolbar-title class="subtitle-2 grey--text">{{ itemsLength }}
              <span v-if="itemsLength == 1">Dirección encontrada</span>
              <span v-else>Direcciones encontradas</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-col>
        <v-col xl="8" lg="9" md="11" sm="12" cols="12" :class="$vuetify.breakpoint.mdAndUp ? 'card-border-bottom':''">
          <v-card class="mx-auto text-left pb-1 card-border-left card-border-right" v-for="address in addresses.addresses" :key="address.address_id" tile flat>
            <v-row no-gutters class="card-border-top">
              <v-col class="center-col" xl="2" lg="2" md="2" sm="2" cols="3">
                <v-icon size="60" color="blue" v-if="$vuetify.breakpoint.mdAndUp">location_on</v-icon>
                <v-icon size="50" color="blue" v-if="$vuetify.breakpoint.smAndDown">location_on</v-icon>
              </v-col>
              <v-col xl="9" lg="9" md="9" sm="9" cols="7" class="px-xl-2 px-lg-2 px-md-2 px-sm-2 px-3 pt-xl-2 pt-lg-2 pt-md-2 pt-sm-1 pt-2 mb-4">
                <div class="text--primary text-left font-weight-light text-lowercase address-title first-capital-letter mt-2">
                  {{ address.name }}
                </div>
                <div class="body-2 text-left font-weight-medium">
                  {{ address.region.name }} {{ address.city.name }}
                </div>
                <div class="body-2 text-left font-weight-medium">
                  <span>{{ address.address }}</span>
                  <span v-if="address.additional_address">&nbsp;{{ address.additional_address }}</span>
                  <span>&nbsp;{{ address.neighborhood }}</span>
                </div>
                <div class="text-left address-subtitle body-2 grey--text mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1">
                  {{ address.cell_phone }}
                  <span v-if="address.landline_phone">&nbsp;- {{ address.landline_phone }}</span>
                </div>
              </v-col>
              <v-col class="center-col pt-xl-5 pt-lg-5 pt-md-5 pt-sm-4 pt-3" xl="1" lg="1" md="1" sm="1" cols="2" align-self="start">
                <v-menu bottom>
                  <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-dots-vertical</v-icon>
                  </template>
                  <v-list class="text-left" dense>
                    <v-list-item @click="goToRouteByName('Update-address', { id: address.address_id })">
                      <v-list-item-icon class="mr-4">
                        <v-icon color="#606060">visibility</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ver</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="confirmation(address)">
                      <v-list-item-icon class="mr-4">
                        <v-icon color="#606060">highlight_off</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="mt-n8" outlined color="transparent">
            <v-card-text >
              <v-fab-transition>
                <v-btn color="#FF5622" dark absolute bottom right fab @click="goToRouteByName('Create-address')">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-text>
          </v-card>
          <confirmation-modal ref="confirmation" title="¿Seguro(a)?" description="¿Quieres eliminar la dirección?" @confirmAction="deleteAddress"></confirmation-modal>
        </v-col>
      </v-row>
    </template>
  </list-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import ConfirmationModal from '@/components/Shared/ConfirmationModal'
import ListContainer from '@/components/List/ListContainer'
import { getErrorMessage } from '@/shared/errors'

export default {
  mixins: [navigationMixin],
  components: {
    ListContainer,
    ConfirmationModal
  },
  data () {
    return {
      selectedAddress: null
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading']),
    ...mapState('address', ['addresses']),
    drawItems () {
      return this.addresses && this.addresses.addresses
    },
    itemsLength () {
      return this.drawItems ? this.addresses.addresses.length : 0
    }
  },
  methods: {
    ...mapActions('address', ['getAddresses', 'removeAddress']),
    confirmation (address) {
      this.selectedAddress = address
      this.$refs.confirmation.openModal()
    },
    async deleteAddress () {
      await this.removeAddress(this.selectedAddress.address_id)
      if (this.error) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('addresses', this.error) })
        return
      }

      this.$emit('notificationPopup', { icon: 'check_circle', color: 'success', message: 'dirección eliminada con éxito' })
    }
  },
  mounted () {
    this.getAddresses()
  }
}
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .toolbar-quantity{
    margin-bottom: 0.5px;
  }

  .address-title{
    font-size: 1.25em;
  }

  .center-col{
    display: flex;
    justify-content: center;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .address-title{
      font-size: 15px;
      line-height: 18px;
    }

    .address-subtitle{
      font-size: 13px !important;
      line-height: 16px;
    }

    .not-found-title{
      font-size: 16px !important;
      line-height: 24px;
    }
  }
</style>
